import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultForm = {
  nbBottlesRemaining: 0,
  valid: false
};
export default {
  name: "TastingPhotoRequiredFormModal",
  components: {
    ErrorModal: ErrorModal
  },
  props: {
    id: Number | null
  },
  data: function data() {
    return {
      dialog: false,
      isLoading: false,
      form: _objectSpread({}, defaultForm),
      dbSyncedValues: null,
      isNbBottlesRemainingFocused: false,
      isUpdatingNbBottlesRemaining: false,
      formRules: formRules,
      filterIntegerKey: filterIntegerKey,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isEditing: function isEditing() {
      return +this.id > 0;
    },
    isAnyFocused: function isAnyFocused() {
      return this.isNbBottlesRemainingFocused;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isUpdatingNbBottlesRemaining;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this2.id) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return _this2.getEntity();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getEntity: function getEntity() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoading = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/tasting-photos/required/".concat(_this3.id), "get", null, true, "api").catch(function (e) {
                _this.isLoading = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get details of tasting photo required", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context2.sent;
              result = _objectSpread({}, response.data.value);
              _this3.form.nbBottlesRemaining = result.nbBottlesRemaining;
              _this3.dbSyncedValues = _objectSpread({}, result);
              _this3.isLoading = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    checkChangeNbBottlesRemaining: function checkChangeNbBottlesRemaining() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$dbSyncedValues, data, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this4.isEditing) {
                _context3.next = 11;
                break;
              }
              if (!(_this4.form.nbBottlesRemaining !== ((_this4$dbSyncedValues = _this4.dbSyncedValues) === null || _this4$dbSyncedValues === void 0 ? void 0 : _this4$dbSyncedValues.nbBottlesRemaining))) {
                _context3.next = 11;
                break;
              }
              _this4.isUpdatingNbBottlesRemaining = true;
              data = {
                nbBottlesRemaining: _this4.form.nbBottlesRemaining
              };
              _this = _this4;
              _context3.next = 7;
              return request("/v1/tasting-photos/required/".concat(+_this4.id, "/nb-bottles-remaining"), "put", data, true, "api").catch(function (e) {
                var _this$dbSyncedValues;
                _this.isUpdatingNbBottlesRemaining = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the number of bottles remaining", true);
                handleErrorData(_this, errorData);
                _this.form.nbBottlesRemaining = (_this$dbSyncedValues = _this.dbSyncedValues) === null || _this$dbSyncedValues === void 0 ? void 0 : _this$dbSyncedValues.nbBottlesRemaining;
                throw e;
              });
            case 7:
              _this4.dbSyncedValues.nbBottlesRemaining = _this4.form.nbBottlesRemaining;
              _this4.isUpdatingNbBottlesRemaining = false;
              _this4.$toasted.show("Nb bottles remaining updated.", {
                type: "success"
              });
              _this4.$emit("entityUpdated", _this4.id);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    open: function open() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.resetData();
              _this5.dialog = true;
              if (!(+_this5.id > 0)) {
                _context4.next = 5;
                break;
              }
              _context4.next = 5;
              return _this5.getEntity();
            case 5:
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                _this5.resolve = resolve;
                _this5.reject = reject;
              }));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    close: function close() {
      this.dialog = false;
      this.resetData();
    },
    resetData: function resetData() {
      this.form = _objectSpread({}, defaultForm);
      this.dbSyncedValues = null;
      this.isLoading = false;
      this.isUpdatingNbBottlesRemaining = false;
    }
  }
};